import React, { useContext, useEffect, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import PieContext from "../../PieContext";
import AutoCompleteLocalC from "../../utils/controlls/AutoComleteLocalC";
import { FiltroRepPlano2DTO } from "../../models/controlls.model";
import ChartCombo from "../../utils/ChartCombo";
import ChartBubble from "../../utils/ChartBubble";
import ChartPie from "../../utils/ChartPie";
//-------------------------------------------------
import ChartLine from "../../utils/ChartLine";
import ChartArea from "../../utils/ChartArea";
//-------------------------------------------------
import { IconButton, Tooltip } from "@material-ui/core";
import icoExcel from "../../assets/images/icoExcel.svg";
import iconPDF from "../../assets/images/iconPDF.png";
import encabezado from "../../assets/images/encabezado.jpg";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { jsPDF } from "jspdf";
import fi from "date-fns/esm/locale/fi/index.js";
import ChartBarras from "../../utils/ChartBar";
// import "./node_modules/interactive-tutorial/build/styles.css";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: "90%",
      height: "90%",
    },
    titulo: {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "#FFFF #FFFF #b1a252 #FFFF",
      padding: "0px 0px 15px 0px",
    },
    filters: {
      flex: "23%",
      marginLeft: "1%",
      marginRigth: "1%",
    },
    filtersMobile: {
      flex: "48%",
      marginLeft: "1%",
      marginRigth: "1%",
    },
    cuerpo: {
      marginTop: "10px",
      width: "100%",
    },
    cuerpoMobile: {
      marginTop: "10px",
      width: "100%",
      overflowX: "scroll",
      overflowY: "hidden",
    },
    encabezado: {
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    texto: { color: "#24135f" },
  })
);

export default function ModalGraficas(props: modalGraficasProps) {
  //#region Const
  const { dataEstadisticaFiltered, añosSelect, filtrosSelect } =
    useContext(PieContext);
  const [open, setOpen] = useState(true);
  const [ltsCampos, setLstCampos] = useState<string[]>([]);
  const [AutoCompleteAgrupa, setAutoCompleteAgrupa] = useState<any[]>([]);
  const [AutoCompleteNoAgrupa, setAutoCompleteNoAgrupa] = useState<any[]>([]);
  const [autoCompleteCampos, setAutocompleteCampos] = useState<any[]>([]);
  const [combinaciones, setCombinaciones] = useState<any[]>([]);
  const [camposSelect, setCamposSelect] = useState<string[]>(["", ""]);
  const [graficaSelect, setGraficaSelect] = useState("");
  const [dataCombo, setDataCombo] = useState<any[]>([]);
  const [dataBubble, setDataBubble] = useState<any[]>([]);
  const [dataPie, setDataPie] = useState<any[]>([]);
  const [dataLine, setDataLine] = useState<any[]>([]);
  const [dataArea, setDataArea] = useState<any[]>([]);
  const [dataBarras, setDataBarras] = useState<any[]>([]);
  const [series, setSeries] = useState<object>({});
  const [filtros, setFiltros] = useState<string[]>([]);
  const [imagenChart, setImagenChart] = useState<any | null>(null);
  const [filtroFecha, setFiltroFecha] = useState<boolean>(false);
  const [filtroVisible, setFiltroVisible] = useState<boolean>(true);

  const classes = useStyles();
  const doc = new jsPDF();
  const tipoGraficas: any[] = [
    { value: "Combo", texto: "Combo", generar: GeneraDataCombo },
    { value: "Burbujas", texto: "Burbujas", generar: GeneraDataBubble },
    { value: "Pastel", texto: "Pastel", generar: GeneraDataPie },
    { value: "Line", texto: "Líneas", generar: GeneraDataLine },
    { value: "Area", texto: "Áreas", generar: GeneraDataArea },
    { value: "Barras", texto: "Barras", generar: GeneraDataBarras },
  ];
  const camposNoAgrupadores: string[] = [
    "Fecha de recepción",
    "Fecha de resolución",
    "Fecha turno",
    "Fecha y hora recepción",
    "Expediente",
    "Sentencias",
    "Observaciones",
    "Consecutivo",
    "Acto impugnado",
    "Acumulado",
    "Sentido general de medios",
    "Id",
    //Por el momento se retira
    "Magistratura",
    //"Entidad",
  ];
  //#endregion Const

  //#region Effects
  useEffect(() => {
    CamposReporte();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    LlenaAutoComplete(ltsCampos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ltsCampos]);

  useEffect(() => {
    setFiltros([]);
    if (
      camposSelect[0].length > 0 &&
      camposSelect[1].length > 0 &&
      graficaSelect.length > 0
    ) {
      tipoGraficas.find((i) => i.value === graficaSelect).generar();
      // graficaSelect === "Combo"
      //   ? GeneraDataCombo()
      //   : graficaSelect === "Burbujas"
      //   ? GeneraDataBubble()
      //   : GeneraDataPie();
    } else if (
      graficaSelect.length > 0 &&
      (camposSelect[0].length > 0 || camposSelect[1].length > 0)
    ) {
      tipoGraficas.find((i) => i.value === graficaSelect).generar();
      // graficaSelect === "Combo"
      //   ? GeneraDataCombo()
      //   : graficaSelect === "Burbujas"
      //   ? GeneraDataBubble()
      //   : GeneraDataPie();
    }

    llenaFiltro(camposSelect);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camposSelect, graficaSelect]);
  //#endregion Effects

  //#region LocalFunctions
  function CamposReporte() {
    let campos: string[] = [];
    for (let obj in dataEstadisticaFiltered[0])
      if (!["id", "Observaciones", "Sentencias"].includes(obj))
        campos.push(obj);

    setLstCampos(campos);
  }

  function LlenaAutoComplete(listaCampos: string[]) {
    let agrupa: any[] = [];
    let noAgrupa: any[] = [];
    listaCampos.forEach((campo) => {
      if (camposNoAgrupadores.includes(campo)) return;

      if (!campo.includes("Año")) agrupa.push({ value: campo, texto: campo });

      noAgrupa.push({ value: campo, texto: campo });
    });

    setAutoCompleteAgrupa(agrupa);
    setAutoCompleteNoAgrupa(noAgrupa);
    setAutocompleteCampos(noAgrupa);
  }

  function DistinctCampo(distinctC: string): string[] {
    return dataEstadisticaFiltered.reduce((acc: string[], cval: any) => {
      if (!acc.includes(cval[distinctC])) acc.push(cval[distinctC]);
      return acc;
    }, []);
  }

  function GeneraDataCombo() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let encabezado: string[] = [camposSelect0];
    let esCampoAgrupador = !camposNoAgrupadores.includes(camposSelect1);
    const distinctEncabezado = DistinctCampo(camposSelect0);
    const distinctCuerpo = esCampoAgrupador
      ? DistinctCampo(camposSelect1)
      : [camposSelect1];

    // encabezado=[...encabezado, ...(distinctCuerpo as string[])];
    distinctCuerpo.forEach((cuerpo) => {
      if (cuerpo === undefined) return;

      encabezado.push(cuerpo.toString());
    });
    // if(esCampoAgrupador) encabezado.push("Promedio");
    setSeries({
      [encabezado.length - (esCampoAgrupador ? 2 : 1)]: { type: "line" },
    });
    let combo: any[] = [encabezado];

    distinctEncabezado.forEach((agrupador, idx) => {
      let fila: any[] = [agrupador];
      // let sumaDato = 0;
      encabezado.forEach((campo) => {
        if (campo !== camposSelect0 && campo !== "Promedio") {
          let count = dataEstadisticaFiltered.reduce(
            (acc: number, cval: any) => {
              if (
                [null, undefined].includes(cval[camposSelect0]) ||
                [null, undefined].includes(cval[camposSelect1])
              ) {
                return acc;
              }

              if (
                cval[camposSelect0].toString() === agrupador &&
                cval[camposSelect1].toString() === campo &&
                esCampoAgrupador
              )
                acc++;
              else if (
                !esCampoAgrupador &&
                cval[camposSelect0].toString() === agrupador
              )
                acc++;

              return acc;
            },
            0
          );
          fila.push(count);
          // sumaDato += count;
        }
      });
      // if(esCampoAgrupador){
      //   let promedio = sumaDato/(encabezado.length - 2);
      //   fila.push(promedio > 0 && promedio < 1 ? promedio : Math.trunc(promedio));
      // }
      combo.push(fila);
    });

    setDataCombo(combo);
  }

  function GeneraDataBubble() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let distinctCampos1 = DistinctCampo(camposSelect0);
    let noAgrupados = camposNoAgrupadores.includes(camposSelect1);
    let bubble: any[] = [
      [noAgrupados ? "Campo" : "Campos", "Número", "Promedio", "Nombre"],
    ];

    let datosCampo2: {
      campo: string;
      num: number;
      prom: number;
      nom: string;
    }[] = [];

    distinctCampos1.forEach((campo1) => {
      if (noAgrupados) {
        let datosNoAgrupados = dataEstadisticaFiltered.reduce(
          (acc: any[], cval: any) => {
            if (cval[camposSelect0] === campo1) acc.push(cval);
            return acc;
          },
          []
        );

        datosCampo2.push({
          campo: campo1,
          num: datosNoAgrupados.length,
          prom: 0,
          nom: campo1,
        });
      } else {
        let distinctCampos2 = DistinctCampo(camposSelect1);
        distinctCampos2.forEach((campo2) => {
          let datosNoAgrupados = dataEstadisticaFiltered.reduce(
            (acc: any[], cval: any) => {
              if (
                cval[camposSelect0] === campo1 &&
                cval[camposSelect1] === campo2
              )
                acc.push(cval);
              return acc;
            },
            []
          );

          if (camposSelect0 === camposSelect1 && campo1 === campo2) {
            datosCampo2.push({
              campo: `${campo1}-${campo2}`,
              num: datosNoAgrupados.length,
              prom: 0,
              nom: `${campo1}-${campo2}`,
            });
          } else if (camposSelect0 !== camposSelect1) {
            datosCampo2.push({
              campo: `${campo1}-${campo2}`,
              num: datosNoAgrupados.length,
              prom: 0,
              nom: `${campo1}-${campo2}`,
            });
          }
        });
      }
    });

    datosCampo2.forEach((datosCampo) => {
      bubble.push([
        datosCampo.campo.toString(),
        datosCampo.num,
        datosCampo.num /
          (añosSelect[1] - añosSelect[0] === 0
            ? 1
            : añosSelect[1] - añosSelect[0]),
        datosCampo.nom,
      ]);
    });

    setDataBubble(bubble);
  }

  function GeneraDataPie() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let noAgrupados = camposNoAgrupadores.includes(camposSelect1);
    let distinctCampos1 = DistinctCampo(camposSelect0);
    let pie: any[] = [
      [
        `${camposSelect0}${!noAgrupados ? `-${camposSelect1}` : ""}`,
        "Número de registros",
      ],
    ];

    distinctCampos1.forEach((campo1) => {
      if (noAgrupados) {
        let numRegistros = dataEstadisticaFiltered.reduce(
          (acc: number, cval: any) => {
            if (cval[camposSelect0] === campo1) acc += 1;

            return acc;
          },
          0
        );
        pie.push([campo1.toString(), numRegistros]);
      } else {
        let distinctCampos2 = DistinctCampo(camposSelect1);
        distinctCampos2.forEach((campo2) => {
          let numRegistros = dataEstadisticaFiltered.reduce(
            (acc: number, cval: any) => {
              if (
                cval[camposSelect0] === campo1 &&
                cval[camposSelect1] === campo2
              )
                acc += 1;
              return acc;
            },
            0
          );
          pie.push([`${campo1}-${campo2}`, numRegistros]);
        });
      }
    });

    let pieFiltrado: any[] = [];
    for (let i = 0; i < pie.length; i++) {
      if (pie[i][1] !== 0) pieFiltrado.push(pie[i]);
    }

    setDataPie(pieFiltrado);
  }

  function GeneraDataLine() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let encabezado: string[] = [camposSelect0];
    let esCampoAgrupador = !camposNoAgrupadores.includes(camposSelect1);
    const distinctEncabezado = DistinctCampo(camposSelect0);
    const distinctCuerpo = esCampoAgrupador
      ? DistinctCampo(camposSelect1)
      : [camposSelect1];

    // encabezado=[...encabezado, ...(distinctCuerpo as string[])];
    distinctCuerpo.forEach((cuerpo) => {
      if (cuerpo === undefined) return;

      encabezado.push(cuerpo.toString());
    });
    // if(esCampoAgrupador) encabezado.push("Promedio");
    setSeries({
      [encabezado.length - (esCampoAgrupador ? 2 : 1)]: { type: "line" },
    });
    let combo: any[] = [encabezado];

    distinctEncabezado.forEach((agrupador, idx) => {
      let fila: any[] = [agrupador];
      // let sumaDato = 0;
      encabezado.forEach((campo) => {
        if (campo !== camposSelect0 && campo !== "Promedio") {
          let count = dataEstadisticaFiltered.reduce(
            (acc: number, cval: any) => {
              if (
                cval[camposSelect0] === undefined ||
                cval[camposSelect1] === undefined
              )
                return acc;
              if (cval[camposSelect1] === null) console.log(cval);
              if (
                cval[camposSelect0].toString() === agrupador &&
                cval[camposSelect1].toString() === campo &&
                esCampoAgrupador
              )
                acc++;
              else if (
                !esCampoAgrupador &&
                cval[camposSelect0].toString() === agrupador
              )
                acc++;

              return acc;
            },
            0
          );
          fila.push(count);
          // sumaDato += count;
        }
      });
      // if(esCampoAgrupador){
      //   let promedio = sumaDato/(encabezado.length - 2);
      //   fila.push(promedio > 0 && promedio < 1 ? promedio : Math.trunc(promedio));
      // }
      combo.push(fila);
    });
    setDataLine(combo);
  }

  function GeneraDataArea() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let encabezado: string[] = [camposSelect0];
    let esCampoAgrupador = !camposNoAgrupadores.includes(camposSelect1);
    const distinctEncabezado = DistinctCampo(camposSelect0);
    const distinctCuerpo = esCampoAgrupador
      ? DistinctCampo(camposSelect1)
      : [camposSelect1];

    // encabezado=[...encabezado, ...(distinctCuerpo as string[])];
    distinctCuerpo.forEach((cuerpo) => {
      if (cuerpo === undefined) return;

      encabezado.push(cuerpo.toString());
    });
    // if(esCampoAgrupador) encabezado.push("Promedio");
    setSeries({
      [encabezado.length - (esCampoAgrupador ? 2 : 1)]: { type: "line" },
    });
    let combo: any[] = [encabezado];

    distinctEncabezado.forEach((agrupador, idx) => {
      let fila: any[] = [agrupador];
      // let sumaDato = 0;
      encabezado.forEach((campo) => {
        if (campo !== camposSelect0 && campo !== "Promedio") {
          let count = dataEstadisticaFiltered.reduce(
            (acc: number, cval: any) => {
              if (
                cval[camposSelect0] === undefined ||
                cval[camposSelect1] === undefined
              )
                return acc;

              if (cval[camposSelect1] === null) console.log(cval);
              if (
                cval[camposSelect0].toString() === agrupador &&
                cval[camposSelect1].toString() === campo &&
                esCampoAgrupador
              )
                acc++;
              else if (
                !esCampoAgrupador &&
                cval[camposSelect0].toString() === agrupador
              )
                acc++;

              return acc;
            },
            0
          );
          fila.push(count);
          // sumaDato += count;
        }
      });
      // if(esCampoAgrupador){
      //   let promedio = sumaDato/(encabezado.length - 2);
      //   fila.push(promedio > 0 && promedio < 1 ? promedio : Math.trunc(promedio));
      // }
      combo.push(fila);
    });

    setDataArea(combo);
  }

  function GeneraDataBarras() {
    let camposSelect0: string =
      camposSelect[0] === "" ? camposSelect[1] : camposSelect[0];
    let camposSelect1: string =
      camposSelect[1] === "" ? camposSelect[0] : camposSelect[1];

    let encabezado: string[] = [camposSelect0];
    let esCampoAgrupador = !camposNoAgrupadores.includes(camposSelect1);
    const distinctEncabezado = DistinctCampo(camposSelect0);
    const distinctCuerpo = esCampoAgrupador
      ? DistinctCampo(camposSelect1)
      : [camposSelect1];

    // encabezado=[...encabezado, ...(distinctCuerpo as string[])];
    distinctCuerpo.forEach((cuerpo) => {
      if (cuerpo === undefined) return;

      encabezado.push(cuerpo.toString());
    });
    // if(esCampoAgrupador) encabezado.push("Promedio");
    setSeries({
      [encabezado.length - (esCampoAgrupador ? 2 : 1)]: { type: "line" },
    });
    let combo: any[] = [encabezado];

    distinctEncabezado.forEach((agrupador, idx) => {
      let fila: any[] = [agrupador];
      // let sumaDato = 0;
      encabezado.forEach((campo) => {
        if (campo !== camposSelect0 && campo !== "Promedio") {
          let count = dataEstadisticaFiltered.reduce(
            (acc: number, cval: any) => {
              if (
                cval[camposSelect0] === undefined ||
                cval[camposSelect1] === undefined
              )
                return acc;

              if (cval[camposSelect1] === null) console.log(cval);
              if (
                cval[camposSelect0].toString() === agrupador &&
                cval[camposSelect1].toString() === campo &&
                esCampoAgrupador
              )
                acc++;
              else if (
                !esCampoAgrupador &&
                cval[camposSelect0].toString() === agrupador
              )
                acc++;

              return acc;
            },
            0
          );
          fila.push(count);
          // sumaDato += count;
        }
      });
      // if(esCampoAgrupador){
      //   let promedio = sumaDato/(encabezado.length - 2);
      //   fila.push(promedio > 0 && promedio < 1 ? promedio : Math.trunc(promedio));
      // }
      combo.push(fila);
    });

    setDataBarras(combo);
  }

  function descargaCSV() {
    if (graficaSelect === "Combo") {
      let combo = generaStringCSV(filtraDatosCombo(dataCombo, filtros));
      download(combo.trim(), "Combo");
    }

    if (graficaSelect === "Burbujas") {
      let bubble = generaStringCSV(filtraDatosBubble(dataBubble, filtros));
      download(bubble.trim(), "Bubble");
    }

    if (graficaSelect === "Pastel") {
      let pie = generaStringCSV(filtraDataPie(dataPie, filtros));
      download(pie.trim(), "Pie");
    }

    if (graficaSelect === "Lineas") {
      let pie = generaStringCSV(filtraDataPie(dataLine, filtros));
      download(pie.trim(), "Line");
    }

    if (graficaSelect === "Areas") {
      let pie = generaStringCSV(filtraDataPie(dataArea, filtros));
      download(pie.trim(), "Area");
    }
  }

  function generaStringCSV(data: any[]) {
    return data.reduce((acc: string, cval: any[], idx: number) => {
      cval.forEach((dato, idx) => {
        acc += idx !== 0 ? "," : "";
        acc += `"${dato}"`;
      });
      acc += idx !== data.length - 1 ? "\n" : "";
      return acc;
    }, "");
  }

  function download(down: string, name: string) {
    let blob = new Blob(["\ufeff", down], {
      type: "text/csv;charset=windows-1252;",
    });
    let a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = `${name}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function llenaFiltro(camposS: string[]) {
    if (
      (camposS[0] === "" && camposS[1] !== "") ||
      (camposS[0] !== "" && camposS[1] === "")
    ) {
      let valores = DistinctCampo(camposS[1] !== "" ? camposS[1] : camposS[0]);

      setFiltros([]);
      setCombinaciones(
        valores.reduce((acc: any[], cval: string) => {
          acc.push({ value: cval, texto: cval });
          return acc;
        }, [])
      );
    } else if (camposS[0] !== "" && camposS[1] !== "") {
      let valores = dataEstadisticaFiltered.reduce(
        (acc: string[], cval: any) => {
          let val = `${cval[camposS[0]]}-${cval[camposS[1]]}`;
          if (!acc.includes(val)) acc.push(val);
          return acc;
        },
        []
      );
      setFiltros([]);
      setCombinaciones(
        valores.reduce((acc: any[], cval: string) => {
          acc.push({ value: cval, texto: cval });
          return acc;
        }, [])
      );
    }
    setFiltroVisible(true);
  }

  const generaExel = (csvData: any, fileName: string) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  function filtraDatosCombo(datos: any[], lstFiltros: string[]): any[] {
    if (lstFiltros.length === 0) return datos;

    if (
      camposSelect[0] !== "" &&
      camposSelect[1] !== "" &&
      !lstFiltros[0].includes("-")
    )
      setFiltros([]);

    let posicionesEncabezado: number[] = datos[0].reduce(
      (acc: number[], cval: string, idx: number) => {
        lstFiltros.forEach((filtro) => {
          if (filtro.includes(cval) && !acc.includes(idx)) acc.push(idx);
        });
        return acc;
      },
      []
    );

    // setSeries({ [posicionesEncabezado.length ]: { type: "line" } });

    let posicionesFila: number[] = [];
    for (let i = 0; i < datos.length; i++) {
      lstFiltros.forEach((filtro) => {
        if (filtro.includes(datos[i][0]) && !posicionesFila.includes(i))
          posicionesFila.push(i);
      });
    }

    let encabezado = posicionesEncabezado.reduce(
      (acc: string[], cval: number) => {
        acc.push(datos[0][cval]);
        return acc;
      },
      [datos[0][0]]
    );

    let datosFinal: any[] = [encabezado];

    let filas = posicionesFila.reduce((acc: any[], cval: number) => {
      let fila: any[] = [];

      fila.push(datos[cval][0]);
      posicionesEncabezado.forEach((col) => {
        fila.push(datos[cval][col]);
      });

      acc.push(fila);
      return acc;
    }, []);

    datosFinal.push(...filas);
    return datosFinal;
  }

  function filtraDatosBubble(datos: any[], lstFiltros: string[]): any[] {
    if (lstFiltros.length === 0) return datos;

    if (
      camposSelect[0] !== "" &&
      camposSelect[1] !== "" &&
      !lstFiltros[0].includes("-")
    )
      setFiltros([]);

    if (camposSelect[0] === "" || camposSelect[1] === "") {
      return datos.reduce(
        (acc: any[], cval: any) => {
          lstFiltros.forEach((filtro) => {
            if (cval[0].includes(filtro)) {
              acc.push(cval);
            }
          });
          return acc;
        },
        [datos[0]]
      );
    }

    return datos.reduce(
      (acc: any[], cval: any) => {
        if (lstFiltros.includes(cval[0])) {
          acc.push(cval);
        }
        return acc;
      },
      [datos[0]]
    );
  }

  function filtraDataPie(datos: any[], lstFiltros: string[]): any[] {
    if (lstFiltros.length === 0) return datos;

    if (
      camposSelect[0] !== "" &&
      camposSelect[1] !== "" &&
      !lstFiltros[0].includes("-")
    ) {
      setFiltros([]);
    }

    if (camposSelect[0] === "" || camposSelect[1] === "") {
      return datos.reduce(
        (acc: any[], cval: any) => {
          lstFiltros.forEach((filtro) => {
            if (cval[0].includes(filtro) && cval[1] !== 0) {
              acc.push(cval);
            }
          });
          return acc;
        },
        [datos[0]]
      );
    }

    return datos.reduce(
      (acc: any[], cval: any) => {
        if (lstFiltros.includes(cval[0])) {
          acc.push(cval);
        }
        return acc;
      },
      [datos[0]]
    );
  }

  function generaDatosExcel(): any[] {
    if (graficaSelect === "Combo") return filtraDatosCombo(dataCombo, filtros);
    else if (graficaSelect === "Burbujas")
      return filtraDatosBubble(dataBubble, filtros);
    else if (graficaSelect === "Pastel") return filtraDataPie(dataPie, filtros);
    else return [];
  }

  function guardaImagen(imagen: any) {
    setImagenChart(imagen);
  }
  //#endregion LocalFunctions

  //#region events
  const handleClose = () => {
    setOpen(false);
    props.cerrarModal();
  };

  const btnExcel =
    (data: any[], nombre: string) => (event: React.MouseEvent) => {
      generaExel(data, nombre);
    };

  const btnPDF = (event: React.MouseEvent) => {
    let texto: string = "Filtros:\n";
    let filas: number = 10;
    let encabezados: string[] = [];
    for (let dato in filtrosSelect) {
      if (filtrosSelect[dato].valor.length > 0) {
        if (filtrosSelect[dato].valor[0] !== "") {
          texto += `${dato} (${
            filtrosSelect[dato].operador !== ""
              ? filtrosSelect[dato].operador
              : "entre"
          }): ${filtrosSelect[dato].valor.join()}\n`;
          filas += 5;
        }
      }
    }

    if (filas === 5) texto += "Sin filtros.";

    texto += "\nDatos:\n";
    let datos: any[] =
      graficaSelect === "Combo"
        ? filtraDatosCombo(dataCombo, filtros)
        : graficaSelect === "Burbujas"
        ? filtraDatosBubble(dataBubble, filtros)
        : filtraDataPie(dataPie, filtros);

    for (let dato of datos[0]) encabezados.push(dato);

    let tablaPDF = datos.reduce((acc: any[], cval: any[], idx: number) => {
      if (idx === 0) return acc;
      let id = 0;
      let filaVal: any = {};
      for (let cdato of cval) {
        filaVal[encabezados[id]] = cdato.toString();
        id++;
      }
      acc.push(filaVal);
      return acc;
    }, []);

    doc.addImage(encabezado, "jpg", 10, 10, 190, 20);
    doc.text(
      "                                  Gráfica de información estadística",
      10,
      40
    );
    doc.addImage(imagenChart, "png", 10, 60, 180, 100);
    doc.setFontSize(6);
    doc.text(texto, 10, 150);
    doc.table(10, 150 + filas, tablaPDF, encabezados, {
      printHeaders: true,
      autoSize: true,
      fontSize: 6,
      headerBackgroundColor: "#24135f",
      headerTextColor: "#FFFFFF",
    });
    doc.save("Gráfica");
  };
  //#endregion events

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            className={classes.paper}
            style={{
              overflowX: "scroll",
            }}
          >
            <div className={classes.encabezado}>
              <h3 id="transition-modal-title" style={{ color: "#24135f" }}>
                GRÁFICAS DE INFORMACIÓN ESTADÍSTICA{" "}
                {`${añosSelect[0]}-${añosSelect[1]}`}
              </h3>
              {dataCombo.length > 0 ||
              dataBubble.length > 0 ||
              dataPie.length > 0 ? (
                <>
                  <Tooltip title={"Descarga csv"}>
                    <IconButton onClick={descargaCSV}>
                      <CloudDownloadIcon style={{ color: "#24135f" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Descarga Excel"}>
                    <IconButton
                      onClick={btnExcel(generaDatosExcel(), graficaSelect)}
                    >
                      <img
                        style={{ width: "35px", height: "35px" }}
                        src={icoExcel}
                        alt=""
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Descarga PDF"}>
                    <IconButton onClick={btnPDF}>
                      <img
                        style={{ width: "23px", height: "23px" }}
                        src={iconPDF}
                        alt=""
                      />
                    </IconButton>
                  </Tooltip>
                </>
              ) : null}
              <Tooltip title={"Cerrar"}>
                <IconButton
                  onClick={(event) => {
                    props.cerrarModal();
                  }}
                >
                  <CancelPresentationIcon style={{ color: "#24135f" }} />
                </IconButton>
              </Tooltip>
            </div>
            <div id="Titulo" className={classes.titulo}>
              <div
                className={
                  window.screen.width < 1000
                    ? classes.filtersMobile
                    : classes.filters
                }
              >
                {AutoCompleteAgrupa.length > 0 ? (
                  <AutoCompleteLocalC
                    key={"acl-agrupa"}
                    id={"Variable 1-1"}
                    filtro={false}
                    filtros={{}}
                    graficas={true}
                    opciones={false}
                    multiple={false}
                    datos={AutoCompleteAgrupa}
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      setFiltroVisible(false);
                      setFiltros([]);
                      setCamposSelect([filtro.valor[0] ?? "", camposSelect[1]]);
                      console.log(filtro);
                      setAutoCompleteNoAgrupa(
                        autoCompleteCampos.filter(
                          (i) => !filtro.valor.includes(i.value)
                        )
                      );
                    }}
                  />
                ) : null}
              </div>
              <div
                className={
                  window.screen.width < 1000
                    ? classes.filtersMobile
                    : classes.filters
                }
              >
                {AutoCompleteAgrupa.length > 0 ? (
                  <AutoCompleteLocalC
                    key={"acl-noAgrupa"}
                    id={"Variable 2-1"}
                    filtro={false}
                    filtros={{}}
                    graficas={true}
                    opciones={false}
                    multiple={false}
                    datos={AutoCompleteNoAgrupa}
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      setFiltroVisible(false);
                      setFiltros([]);
                      if (filtro.valor.length > 0) {
                        setFiltroFecha(filtro.valor[0].includes("Fecha"));
                        setCamposSelect([
                          camposSelect[0],
                          filtro.valor[0] ?? "",
                        ]);
                      }
                      setAutoCompleteAgrupa(
                        autoCompleteCampos.filter(
                          (i) =>
                            !filtro.valor.includes(i.value) &&
                            !i.value.includes("Año")
                        )
                      );
                    }}
                  />
                ) : null}
              </div>
              <div
                className={
                  window.screen.width < 1000
                    ? classes.filtersMobile
                    : classes.filters
                }
              >
                {AutoCompleteAgrupa.length > 0 ? (
                  <AutoCompleteLocalC
                    key={"acl-tipoGrafica"}
                    id={"Tipo gráfica-1"}
                    filtro={false}
                    filtros={{}}
                    graficas={true}
                    opciones={false}
                    multiple={false}
                    datos={tipoGraficas}
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      setFiltroVisible(false);
                      setFiltros([]);
                      setGraficaSelect(filtro.valor[0] ?? "");
                    }}
                  />
                ) : null}
              </div>
              <div
                className={
                  window.screen.width < 1000
                    ? classes.filtersMobile
                    : classes.filters
                }
              >
                {AutoCompleteAgrupa.length > 0 &&
                !filtroFecha &&
                filtroVisible ? (
                  <AutoCompleteLocalC
                    key={"acl-filtrosGrafica"}
                    id={"Filtros-1"}
                    filtro={false}
                    filtros={{}}
                    graficas={true}
                    opciones={false}
                    multiple={false}
                    datos={combinaciones}
                    // values={filtros}
                    eliminaInput={(idCampo: string, filtroInput: boolean) => {}}
                    guardaSeleccion={(
                      campo: string,
                      filtro: FiltroRepPlano2DTO
                    ) => {
                      setFiltros(filtro.valor ?? []);
                    }}
                  />
                ) : null}
              </div>
            </div>
            <div
              className={
                window.screen.width < 1000
                  ? classes.cuerpoMobile
                  : classes.cuerpo
              }
            >
              {dataCombo.length > 0 && graficaSelect === "Combo" ? (
                <ChartCombo
                  data={filtraDatosCombo(dataCombo, filtros)}
                  series={series}
                  title={`Núm. registros, ${camposSelect[0]} vs ${camposSelect[1]}. (eje X: ${camposSelect[0]}, eje Y: ${camposSelect[1]})`}
                  descripcionH={`${camposSelect[0]}(s) encontrados(as)`}
                  descripcionV={`Núm. de registros encontrados`}
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
              {dataBubble.length > 0 && graficaSelect === "Burbujas" ? (
                <ChartBubble
                  data={filtraDatosBubble(dataBubble, filtros)}
                  title={`Promedio por año, ${camposSelect[0]} vs ${camposSelect[1]}. (eje X: Núm. registros, eje Y: Prom. por año)`}
                  hAxis={`Número de registros encontrados`}
                  vAxis="Promedio por año"
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
              {dataPie.length > 0 && graficaSelect === "Pastel" ? (
                <ChartPie
                  title={`Porcentaje ${camposSelect[0]}-${camposSelect[1]}`}
                  data={filtraDataPie(dataPie, filtros)}
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
              {dataLine.length > 0 && graficaSelect === "Line" ? (
                <ChartLine
                  data={filtraDatosCombo(dataLine, filtros)}
                  title={`Núm. registros, ${camposSelect[0]} vs ${camposSelect[1]}. (eje X: ${camposSelect[0]}, eje Y: ${camposSelect[1]})`}
                  descripcionH={`${camposSelect[0]}(s) encontrados(as)`}
                  descripcionV={`Núm. de registros encontrados`}
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
              {dataArea.length > 0 && graficaSelect === "Area" ? (
                <ChartArea
                  data={filtraDatosCombo(dataArea, filtros)}
                  title={`Núm. registros, ${camposSelect[0]} vs ${camposSelect[1]}. (eje X: ${camposSelect[0]}, eje Y: ${camposSelect[1]})`}
                  descripcionH={`${camposSelect[0]}(s) encontrados(as)`}
                  descripcionV={`Núm. de registros encontrados`}
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
              {dataBarras.length > 0 && graficaSelect === "Barras" ? (
                <ChartBarras
                  data={filtraDatosCombo(dataBarras, filtros)}
                  title={`Núm. registros, ${camposSelect[0]} vs ${camposSelect[1]}. (eje X: ${camposSelect[0]}, eje Y: ${camposSelect[1]})`}
                  descripcionH={`${camposSelect[0]}(s) encontrados(as)`}
                  descripcionV={`Núm. de registros encontrados`}
                  getImage={(img: any) => {
                    guardaImagen(img);
                  }}
                />
              ) : null}
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

interface modalGraficasProps {
  cerrarModal(): void;
}
